import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { UpdateRequestBase } from '@models/base/updateRequestBase.model';
import { CreatePagoComprobanteRequest } from '@models/pagos-comprobantes/createPagoComprobanteRequest.model';
import { PagoComprobanteDetailDto } from '@models/pagos-comprobantes/pagoComprobanteDetailDto.model';
import { PagoComprobanteDto } from '@models/pagos-comprobantes/pagoComprobanteDtoPago.model';
import { PagoComprobanteFilter } from '@models/pagos-comprobantes/pagoComprobanteFilter.model';
import { UpdatePagoComprobanteRequest } from '@models/pagos-comprobantes/updatePagoComprobanteRequest.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PagoscomprobantesService {


  constructor(
    private http: HttpClient
  ) { }

  /**
   * *Crear pagos comprobante
   * @param createComprobanteRequest
   * @returns
   */
  create(createPagoComprobanteRequest: CreatePagoComprobanteRequest): Observable<CreateResponseBase> {
    return this.http.post<CreateResponseBase>("/api/PagoComprobante/Create", createPagoComprobanteRequest);
  }

  /**
   * *Actualizar pagos comprobante.
   * @param updateRequestBase
   * @returns
   */
  update(updatePagoComprobanteRequest: UpdatePagoComprobanteRequest): Observable<any> {
    return this.http.put<UpdateRequestBase>("/api/PagoComprobante/Update", updatePagoComprobanteRequest);
  }

  /**
   * *Obtener todos los pagos comprobante.
   * @returns
   */
  getAll(): Observable<PagoComprobanteDto[]> {
    return this.http.get<PagoComprobanteDto[]>("/api/PagoComprobante/GetAll");
  }

  /**
   * *Obtener pagos comprobante. por Id de pagos comprobante.
   * @param id
   * @returns
   */
  getById(id: number): Observable<PagoComprobanteDto> {
    return this.http.get<PagoComprobanteDto>("/api/PagoComprobante/GetById?id=" + id);
  }


  getPagosComprobantesByFilter(filter: PagoComprobanteFilter): Observable<PagoComprobanteDetailDto[]> {
  let params = new HttpParams();

  if (filter.dateFrom && filter.dateTo) {
    params = params.set('dateFrom', filter.dateFrom);
    params = params.set('dateTo', filter.dateTo);
  }

  if (filter.fechaAcreditacionDesde)
    params = params.set('fechaAcreditacionDesde', filter.fechaAcreditacionDesde);

  if (filter.fechaAcreditacionHasta)
    params = params.set('fechaAcreditacionHasta', filter.fechaAcreditacionHasta);

  filter.idsFormaPago?.forEach(id => {
    params = params.append('idsFormaPago', id.toString());
  });

  filter.idsEstadoPago?.forEach(id => {
    params = params.append('idsEstadoPago', id.toString());
  });

  if (filter.idContrato)
    params = params.set('idContrato', filter.idContrato.toString());

  return this.http.get<PagoComprobanteDetailDto[]>(
    '/api/PagoComprobante/GetPagosComprobantesByFilter', { params }
  );
}


}
